/**
 * TanStack Query hooks for missing-in-SCH projects (SCH-5.6).
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { missingProjectsService } from '@/services/integrations/missingProjectsService';
import type { MissingProjectDecision } from '@/types/integrations/missingProjects';

const MISSING_PROJECTS_KEY = ['sch', 'missing-projects'] as const;

export function useMissingProjects() {
  return useQuery({
    queryKey: MISSING_PROJECTS_KEY,
    queryFn: () => missingProjectsService.listMissingProjects(),
    staleTime: 30_000,
  });
}

export function useDecideMissingProject() {
  const queryClient = useQueryClient();
  return useMutation<
    Awaited<ReturnType<typeof missingProjectsService.decideMissingProject>>,
    Error,
    { projectId: string; decision: MissingProjectDecision }
  >({
    mutationFn: ({ projectId, decision }) =>
      missingProjectsService.decideMissingProject(projectId, decision),
    onSuccess: (result) => {
      if (result.data) {
        queryClient.invalidateQueries({ queryKey: MISSING_PROJECTS_KEY });
      }
    },
    retry: false,
  });
}

export { MISSING_PROJECTS_KEY };
